import { axios } from '@Root/API'

export const getAll = (courseSessionId, params) => {
  return axios.get(`/get/post-grad/student-course-session/${courseSessionId}`, { params })
}
